import { render } from "./BasicLayout.vue?vue&type=template&id=4f789bb4&scoped=true"
import script from "./BasicLayout.vue?vue&type=script&lang=js"
export * from "./BasicLayout.vue?vue&type=script&lang=js"

import "./BasicLayout.vue?vue&type=style&index=0&id=4f789bb4&lang=less&scoped=true"
import "./BasicLayout.vue?vue&type=style&index=1&id=4f789bb4&lang=less"

import exportComponent from "/builds/cloud-game/goc_backstage_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f789bb4"]])

export default __exports__